<app-content-header [contentHeader]="contentHeader"></app-content-header>

<div class="col-12 row" *ngIf="isUpdate">
    <div class="card col-xl-8 col-md-10 col-sm-12"
        [ngClass]="{'border-success': person.personalAdditionalInfarmation?.workingStatus, 'border-danger': !person.personalAdditionalInfarmation?.workingStatus}">
        <div class="card-body">
            <!-- Personal Information -->

            <h4 class="card-title mb-1">{{person.name}} {{person.lastName}}</h4>
            <h6 class="card-subtitle text-muted mb-2">{{person.personalAdditionalInfarmation?.department}} •
                {{person.mission}} - {{person.personalAdditionalInfarmation?.registrationNumber}}</h6>

            <!-- Details Split into Columns -->
            <div class="row">
                <div class="col-md-4">
                    <div *ngIf="person.phoneNumber" class="form-group row">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Tel No</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [(ngModel)]="person.phoneNumber" />
                        </div>
                    </div>

                    <div *ngIf="person.personalAdditionalInfarmation?.birthDay" class="form-group row">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">D.T</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [value]="person.personalAdditionalInfarmation.birthDay | date:'dd.MM.yyyy'" />
                        </div>
                    </div>

                    <div *ngIf="person.personalAdditionalInfarmation?.startDate" class="form-group row">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">B.T</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [value]="person.personalAdditionalInfarmation.startDate | date:'dd.MM.yyyy'" />
                        </div>
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group row" *ngIf="person.personalAdditionalInfarmation?.tc">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">TC</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [(ngModel)]="person.personalAdditionalInfarmation.tc" />
                        </div>
                    </div>

                    <div *ngIf="person.personalAdditionalInfarmation?.wage" class="form-group row">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Maaş</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [(ngModel)]="person.personalAdditionalInfarmation.wage" />
                        </div>
                    </div>

                    <div *ngIf="person.personalAdditionalInfarmation?.registrationNumber" class="form-group row">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Sicil No</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [(ngModel)]="person.personalAdditionalInfarmation.registrationNumber" />
                        </div>
                    </div>
                </div>

                <div class="col-md-5">
                    <div class="form-group row" *ngIf="person.mail">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Email</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [(ngModel)]="person.mail" />
                        </div>
                    </div>

                    <div class="form-group row" *ngIf="person.address">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Adres</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [value]="person.address" />
                        </div>
                    </div>

                    <div class="form-group row" *ngIf="person.personalAdditionalInfarmation?.emergencyContact">
                        <div class="col-sm-4 col-form-label">
                            <label for="basicInput">Acil Kontak</label>
                        </div>
                        <div class="col-sm-8">
                            <input type="text" class="form-control" id="disabledInput" disabled
                                [value]="person.personalAdditionalInfarmation.emergencyContact" />
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="person.personalAdditionalInfarmation?.workingDays?.length > 0">
                <h5>Mesai Saatleri:</h5>
                <div class="row">
                    <div class="col-3"
                        *ngFor="let group of splitWorkingDays(person.personalAdditionalInfarmation?.workingDays, 2)">
                        <ul class="list-unstyled">
                            <li *ngFor="let day of group" class="mb-1">
                                <strong>{{getDayLabel(day.day)}}:</strong> {{day.start}} - {{day.end}}
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Buttons -->
            <div class="d-flex justify-content-end align-items-center">
                <div>
                    <button type="button" class="btn btn-icon btn-outline-warning"
                        *ngIf="authService.isEndpointStatus('PUT.Updateing.UpdateWorker')" (click)="updateChange()"
                        rippleEffect>
                        <span [data-feather]="'edit'"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>


    <div class="col-xl-4 col-md-8 col-sm-12 row d-flex justify-content-between ml-1">
        <div class="card text-center col-xl-6 col-md-6 col-sm-12">
            <div class="card-body">
                <div class="avatar bg-info bg-darken-2 p-50 m-0 mb-1">
                    <div class="avatar-content">
                        <i data-feather="clock" class="font-medium-5"></i>
                    </div>
                </div>
                <h4 class="font-weight-bolder">{{calculate?.last7Days | number:'1.1-2'}}</h4>
                <p class="mb-0 line-ellipsis small-text">Son 7 Gün</p>
            </div>
        </div>

        <div class="card text-center col-xl-6 col-md-6 col-sm-12">
            <div class="card-body">
                <div class="avatar bg-warning bg-darken-2 p-50 m-0 mb-1">
                    <div class="avatar-content">
                        <i data-feather="clock" class="font-medium-5"></i>
                    </div>
                </div>
                <h4 class="font-weight-bolder">{{calculate?.last1Month | number:'1.1-2'}}</h4>
                <p class="mb-0 line-ellipsis small-text">Son 1 Ay</p>
            </div>
        </div>
        <div class="card text-center col-xl-6 col-md-6 col-sm-12">
            <div class="card-body">
                <div class="avatar bg-primary bg-darken-2 p-50 m-0 mb-1">
                    <div class="avatar-content">
                        <i data-feather="clock" class="font-medium-5"></i>
                    </div>
                </div>
                <h4 class="font-weight-bolder">{{calculate?.last1Year | number:'1.1-2'}}</h4>
                <p class="mb-0 line-ellipsis small-text">Son 1 Yıl</p>
            </div>
        </div>

        <div class="card text-center col-xl-6 col-md-6 col-sm-12">
            <div class="card-body">
                <div class="avatar bg-danger bg-darken-2 p-50 m-0 mb-1">
                    <div class="avatar-content">
                        <i data-feather="clock" class="font-medium-5"></i>
                    </div>
                </div>
                <h4 class="font-weight-bolder">{{calculate?.overtimeHours | number:'1.1-2'}}</h4>
                <p class="mb-0 line-ellipsis small-text">Toplam Fazla Mesai Saati</p>
            </div>
        </div>
    </div>
</div>

<!-- <div class="card col-12" *ngIf="!isUpdate">
    <form [formGroup]="personForm">
        <div class="row">
            <div class="col-2">
                <label for="title">İsim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="name" formControlName="name" maxlength="30" />
                    </div>
                    <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched" class="text-danger">
                        İsim zorunludur.
                    </div>
                </div>
            </div>
            <div class="col-2">
                <label for="description">Soyisim</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="lastName" formControlName="lastName"
                            maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                        class="text-danger">
                        Soyisim zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-2">
                <label for="department">Departman</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="department" formControlName="department"
                        maxlength="50" />
                </div>
            </div>

            <div class="col-2">
                <label for="description">Görev</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="mission" formControlName="mission" maxlength="50" />
                    </div>
                    <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched"
                        class="text-danger">
                        Görev zorunludur.
                    </div>
                </div>
            </div>

            <div class="col-4">
                <label for="description">Email</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="email" class="form-control" id="mail" formControlName="mail" />
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-2">
                <label for="birthDay">Doğum Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" formControlName="birthDay"
                        [setDate]="birthDate  ?? date"></ng2-flatpickr>
                </div>
            </div>
            <div class="col-2">
                <label for="startDate">İşe Başlama Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime" formControlName="startDate"
                        [setDate]="startDate ?? date"></ng2-flatpickr>
                </div>
            </div>

            <div class="col-2">
                <label for="description">Tel No</label>
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" class="form-control" id="phoneNumber" formControlName="phoneNumber"
                            mask="(000) 000 00 00" />
                    </div>

                </div>
            </div>
            <div class="col-2">
                <label for="tc">T.C. Kimlik No</label>
                <div class="form-group">
                    <input type="text" class="form-control" id="tc" formControlName="tc" maxlength="11" />
                </div>
            </div>
            <div class="col-1">
                <label for="wage">Maaş</label>
                <div class="form-group">
                    <input type="number" class="form-control" id="wage" formControlName="wage" />
                </div>
            </div>

            <div class="col-1">
                <label for="workingStatus">Çalışma Durumu</label>
                <div class="form-group">
                    <input type="checkbox" id="workingStatus" formControlName="workingStatus" />
                </div>
            </div>

            <div class="col-2" *ngIf="!personForm.value.workingStatus">
                <label for="leaveJob">İşten Ayrılma Tarihi</label>
                <div class="form-group">
                    <ng2-flatpickr [config]="dateTimeLeaveJobOptions" name="dateTime" formControlName="leaveJob"
                        [setDate]="leaveDate ?? date"></ng2-flatpickr>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-6">
                <label for="emergencyContact">Acil Durum Kontağı</label>
                <div class="form-group">
                    <textarea class="form-control" id="emergencyContact" formControlName="emergencyContact"
                        maxlength="50"></textarea>
                </div>
            </div>
            <div class="col-6">
                <label for="description">Adres</label>
                <div class="form-group">
                    <div class="input-group">
                        <textarea class="form-control" id="address" formControlName="address"
                            maxlength="200"></textarea>
                    </div>
                </div>
            </div>

        </div>
    </form>
</div> -->

<section class="vertical-wizard" *ngIf="!isUpdate">
    <div id="stepper2" class="bs-stepper vertical vertical-wizard-example">
        <div class="bs-stepper-header">
            <div class="step" data-target="#account-details">
                <button class="step-trigger" (click)="updateBtStepper(0)">
                    <span class="bs-stepper-box">1</span>
                    <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Kişisel Bilgiler</span>
                        <span class="bs-stepper-subtitle">Kişisel Bilgiler</span>
                    </span>
                </button>
            </div>
            <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
            <div class="step" data-target="#personal-info">
                <button class="step-trigger" (click)="updateBtStepper(1)">
                    <span class="bs-stepper-box">2</span>
                    <span class="bs-stepper-label">
                        <span class="bs-stepper-title">İletişim Bilgileri</span>
                        <span class="bs-stepper-subtitle">İletişim Bilgileri</span>
                    </span>
                </button>
            </div>
            <div class="line"><i data-feather="chevron-right" class="font-medium-2"></i></div>
            <div class="step" data-target="#social-links">
                <button class="step-trigger" (click)="updateBtStepper(2)">
                    <span class="bs-stepper-box">3</span>
                    <span class="bs-stepper-label">
                        <span class="bs-stepper-title">Mesai Saatleri</span>
                        <span class="bs-stepper-subtitle">Çalışma günleri ve maaş bilgileri</span>
                    </span>
                </button>
            </div>
        </div>
        <div class="bs-stepper-content">
            <form (ngSubmit)="personForm.valid" [formGroup]="personForm">
                <div id="account-details" class="content">
                    <form [formGroup]="personForm">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="form-group col-md-12">
                                    <label class="form-label" for="name">İsim</label>
                                    <input formControlName="name" id="name" class="form-control" placeholder="John" />
                                    <div *ngIf="personForm.get('name').invalid && personForm.get('name').touched"
                                        class="invalid-feedback">
                                        <small *ngIf="personForm.get('name').errors?.required">İsim girilmesi
                                            zorunludur!</small>
                                    </div>
                                </div>
                                <div class="form-group col-md-12">
                                    <label class="form-label" for="lastName">Soyisim</label>
                                    <input formControlName="lastName" id="lastName" class="form-control"
                                        placeholder="Doe" />
                                    <div *ngIf="personForm.get('lastName').invalid && personForm.get('lastName').touched"
                                        class="invalid-feedback">
                                        <small *ngIf="personForm.get('lastName').errors?.required">Soyadı
                                            zorunludur</small>
                                    </div>
                                </div>

                                <div class="form-group col-md-12">
                                    <label class="form-label" for="mission">Görev</label>
                                    <input formControlName="mission" id="mission" class="form-control"
                                        placeholder="Manager" />
                                    <div *ngIf="personForm.get('mission').invalid && personForm.get('mission').touched"
                                        class="invalid-feedback">
                                        <small *ngIf="personForm.get('mission').errors?.required">Görev Zorunlu!</small>
                                    </div>
                                </div>

                            </div>

                            <div class="col-md-4">
                                <div class="form-group col-md-12">
                                    <label class="form-label" for="department">Departman</label>
                                    <input formControlName="department" id="department" class="form-control"
                                        placeholder="IT" />
                                </div>

                                <div class="form-group col-md-12">
                                    <label class="form-label" for="tc">TC No</label>
                                    <input formControlName="tc" id="tc" class="form-control"
                                        placeholder="12345678901" />
                                    <div *ngIf="personForm.get('tc').invalid && personForm.get('tc').touched"
                                        class="invalid-feedback">
                                        <small *ngIf="personForm.get('tc').errors?.required">This field is
                                            required!</small>
                                        <small *ngIf="personForm.get('tc').errors?.maxlength">TC Number must be 11
                                            digits!</small>
                                    </div>
                                </div>

                                <div class="form-group col-md-12">
                                    <label class="form-label" for="phoneNumber">Sicil No</label>
                                    <input formControlName="registrationNumber" id="registrationNumber"
                                        class="form-control" placeholder="Sicil No" />
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group col-md-12">
                                    <label class="form-label" for="birthDay">Doğum Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime"
                                        formControlName="birthDay" [setDate]="birthDate  ?? date"></ng2-flatpickr>

                                </div>
                                <div class="form-group col-md-12">
                                    <label class="form-label" for="startDate">İşe Başlama Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeEndOptions" name="dateTime"
                                        formControlName="startDate" [setDate]="startDate ?? date"></ng2-flatpickr>
                                </div>

                                <div class="form-group custom-control custom-checkbox col-md-10 ml-1">
                                    <input type="checkbox" class="custom-control-input" id="customCheck1"
                                        formControlName="workingStatus" />
                                    <label class="custom-control-label" for="customCheck1">Çalışma Durumu</label>
                                </div>

                                <div class="form-group col-md-12" *ngIf="!personForm.value.workingStatus">
                                    <label class="form-label" for="startDate">İşten Ayrılma Tarihi</label>
                                    <ng2-flatpickr [config]="dateTimeLeaveJobOptions" name="dateTime"
                                        formControlName="leaveJob" [setDate]="leaveDate ?? date"></ng2-flatpickr>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
                <div id="personal-info" class="content">
                    <div class="row">
                        <div class="form-group col-md-6">
                            <label class="form-label" for="address">Adres</label>
                            <textarea formControlName="address" id="address" class="form-control" rows="3"
                                placeholder="Adres"></textarea>
                        </div>

                        <div class="form-group col-md-6">
                            <label class="form-label" for="emergencyContact">Acil Kontak</label>
                            <textarea formControlName="emergencyContact" id="emergencyContact" class="form-control"
                                rows="3" placeholder="Acil Kontak"></textarea>
                        </div>

                        <div class="form-group col-md-6">
                            <label class="form-label" for="mail">Email</label>
                            <input formControlName="mail" id="mail" class="form-control"
                                placeholder="john.doe@email.com" />
                        </div>
                        <div class="form-group col-md-6">
                            <label class="form-label" for="phoneNumber">Tel No</label>
                            <input formControlName="phoneNumber" id="phoneNumber" class="form-control"
                                placeholder="555-1234" />
                        </div>

                    </div>
                </div>

                <div id="social-links" class="content">
                    <div class="container">
                        <form #timeForm="ngForm">
                            <div class="row" *ngFor="let day of days" class="d-flex align-items-center">
                                <!-- Checkbox ve gün etiketi -->
                                <div class="custom-control custom-checkbox col-md-1">
                                    <input type="checkbox" class="custom-control-input" [id]="day.name"
                                        [(ngModel)]="day.selected" name="{{ day.name }}Checked" />
                                    <label class="custom-control-label" [for]="day.name" style="font-size: 0.7rem;">{{
                                        day.label }}
                                    </label>
                                </div>

                                <!-- Başlangıç saati -->
                                <div *ngIf="day.selected" class="col-md-4 ml-2 d-flex align-items-center">
                                    <label class="mr-2" style="font-size: 0.7rem;">Başlangıç</label>
                                    <ngb-timepicker [(ngModel)]="day.startTime" name="{{ day.name }}StartTime"
                                        [spinners]="false" class="timepicker"></ngb-timepicker>
                                </div>

                                <!-- Bitiş saati -->
                                <div *ngIf="day.selected" class="col-md-4 d-flex align-items-center">
                                    <label class="mr-2" style="font-size: 0.7rem;">Bitiş</label>
                                    <ngb-timepicker [(ngModel)]="day.endTime" name="{{ day.name }}EndTime"
                                        [spinners]="false" class="timepicker"></ngb-timepicker>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="form-group col-md-3">
                        <label class="form-label" for="phoneNumber">Maaş</label>
                        <input formControlName="wage" id="wage" class="form-control" placeholder="0" />
                    </div>
                </div>
                <div class="d-flex justify-content-end button-container">
                    <button (click)="horizontalWizardStepperPrevious()" class="btn btn-outline-secondary btn-prev mr-1"
                        [disabled]="!personForm.valid">
                        <i data-feather="arrow-left" class="align-middle mr-sm-25 mr-0"></i>
                        <span class="align-middle d-sm-inline-block d-none">Geri</span>
                    </button>

                    <button type="button" class="btn btn-icon btn-danger mr-1" (click)="updateChange()" rippleEffect>
                        <span [data-feather]="isUpdate ? 'edit' : 'x'">{{ isUpdate == false ? 'İptal' : 'Güncelle'
                            }}</span>
                    </button>

                    <button *ngIf="stepIndex !== 2" (click)="horizontalWizardStepperNext(personForm)" type="submit"
                        class="btn btn-primary btn-next" [disabled]="!personForm.valid">
                        <span class="align-middle d-sm-inline-block d-none">İleri</span>
                        <i data-feather="arrow-right" class="align-middle ml-sm-25 ml-0"></i>
                    </button>

                    <button *ngIf="stepIndex === 2" (click)="onSumbit()" class="btn btn-success btn-next"
                        [disabled]="!personForm.valid">
                        Kaydet
                    </button>
                </div>

            </form>
        </div>
    </div>
</section>

<ul ngbNav #nav="ngbNav" class="nav-tabs mt-2">
    <li ngbNavItem *ngIf="authService.isEndpointStatus('GET.Reading.GetPersonByIdLeaves')">
        <a ngbNavLink>İzinler</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-worker-leave-list [personId]="personId"></app-worker-leave-list>
                </div>
            </div>
        </ng-template>
    </li>
    <li ngbNavItem *ngIf="authService.isEndpointStatus('GET.Reading.GetAllByPersonIdPayroll')">
        <a ngbNavLink>Bordro</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-payroll-list [personId]="personId"></app-payroll-list>
                </div>
            </div>
        </ng-template>
    </li>
    <li ngbNavItem *ngIf="authService.isEndpointStatus('GET.Reading.GetAllPersonByIdPoints')">
        <a ngbNavLink>Puantaj</a>
        <ng-template ngbNavContent>
            <div class="card">
                <div class="card-body table-responsive">
                    <app-point-list [personId]="personId"></app-point-list>
                </div>
            </div>
        </ng-template>
    </li>
</ul>
<div [ngbNavOutlet]="nav" class="mt-2"></div>